import { Button, Theme, withStyles } from '@material-ui/core'

export const SuccessButton = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.dark
    }
  }
}))(Button)

export const CancelButton = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  }
}))(Button)

export const WarningButton = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark
    }
  }
}))(Button)
